// book an appointment for mobile view
document.addEventListener('DOMContentLoaded', function() {
  var mobileNavLinks = document.getElementsByClassName('appear-delay-9');
  Array.from(mobileNavLinks).forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      Calendly.initPopupWidget({ url: 'https://calendly.com/diamoreantwerp' });
    });
  });
});

// hide the finger size

// Check if the current page is the desired collection product details page
if (window.location.href.includes('/collections/fine-jewelery/products/necklaces')) {
  // Target specific elements and modify their properties
  var element = document.querySelector('.F_size_label');
  element.style.display = 'none'; // Hide the element
   
  if (element.style.display === 'none') {
    sizeButton.value = ''; // Set the value to empty
  }
}
if (window.location.href.includes('/collections/fine-jewelery/products/earrings')) {
  // Target specific elements and modify their properties
  var element = document.querySelector('.F_size_label');
  element.style.display = 'none'; // Hide the element
   
  if (element.style.display === 'none') {
    sizeButton.value = ''; // Set the value to empty
  }
}
if (window.location.href.includes('/collections/fine-jewelery/products/bracelets')) {
  // Target specific elements and modify their properties
  var element = document.querySelector('.F_size_label');
  element.style.display = 'none'; // Hide the element
   
  if (element.style.display === 'none') {
    sizeButton.value = ''; // Set the value to empty
  }
}

if (window.location.href.includes('/collections/earrings')) {
  // Target specific elements and modify their properties
  var element = document.querySelector('.F_size_label');
  element.style.display = 'none'; // Hide the element
   
  if (element.style.display === 'none') {
    sizeButton.value = ''; // Set the value to empty
  }
}

if (window.location.href.includes('/collections/bracelets')) {
  // Target specific elements and modify their properties
  var element = document.querySelector('.F_size_label');
  element.style.display = 'none'; // Hide the element
   
  if (element.style.display === 'none') {
    sizeButton.value = ''; // Set the value to empty
  }
}

if (window.location.href.includes('/collections/necklaces')) {
  // Target specific elements and modify their properties
  var element = document.querySelector('.F_size_label');
   element.disabled = true; // Disable the element
  element.style.display = 'none'; // Hide the element
  var sizeButton = document.getElementById('sizeButton');
  
  if (element.style.display === 'none') {
    sizeButton.value = ''; // Set the value to empty
  }
}

// add the tooltip



/* Open the sidebar */
    function openSidebar() {
      document.getElementById('ringSidebar').className += ' ringSidebarOpen';
      document.getElementsByTagName("body")[0].style ='width: 100%; position: absolute;top: 0; z-index: 99;overflow: hidden !important;' 
     document.getElementById("shopify-section-template--18183964393753__ed7c08a5-b1c9-4b7f-a76f-77fad3233770").style=" width: 100%; height: 100%; background-color: rgb(230 230 230 / 36%); position: absolute;top: 0; z-index: 99;";
      
      document.getElementById("sidebar").style= 'width: 450px; right:0;'
    }
    
    /* Close the sidebar */
    function closeSidebar() {
      var ringSidebarOpen = document.querySelector(".ringSidebarOpen");
      ringSidebarOpen.classList.remove("ringSidebarOpen");
      document.getElementsByTagName("body")[0].style ='overflow: visible !important' 
      document.getElementById("shopify-section-template--18183964393753__ed7c08a5-b1c9-4b7f-a76f-77fad3233770").style="position: relative;top: 0; z-index: 99;";
      document.getElementById("sidebar").style= 'right: -500px;'
    }
    
    /* Select a value and update the input button */
    function selectValue(value) {
      document.getElementById("input-button-text").innerHTML = value;
      closeSidebar();
    }
/*Size*/

// $('select').change(function(){
//     if($(this).val() != "-1")
//     {
//     $('table.table').hide();
//     $('table#'+$(this).val()).show();
//     }
// })
document.querySelector('select').addEventListener('change', function() {
  if (this.value !== "-1") {
    document.querySelectorAll('table.table').forEach(function(table) {
      table.style.display = 'none';
    });
    document.querySelector('table#' + this.value).style.display = 'table';
  }
});

/* When the user clicks on the button, 
toggle between hiding and showing the dropdown content */
function myFunction() {
  document.getElementById("myDropdown").classList.toggle("show");
}

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.dropbtn')) {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }
}


// const inputs= doucument.querySelector('form')
// const btn= document.querySelector('button')
// btn.addEventListener('click', ()=>{
//   Email.send({
//     Host:"sandbox.smtp.mailtrap.io",
//     Username:"879698fb61615d",
//     Password:"d12fd31b534170";
//     To:"dev@collationhub.com";
//     From:inputs.elements["email"].value,
//     Subject:"Enquery Form",
//     Body:inputs.elements["message"].value+ "<br>"+ inputs.elements["name"].value + "<br>" + inputs.elements["email"].value + "<br>" + inputs.elements["phone"].value  
//   }).then(msg=>alert("The email succesful"))
// })









